<template>
   <div :class="{hasError:isError}" style="width: 100%;"> 
    <div class="textbox" style="width: 100%;">
        <label>Manufacturer Search Term</label>
        <div>
            <InputText :placeholder="placeholder" 
            v-model="ManufacturerCode" 
            :disabled="disabled"/>
            <Button label="Check" severity="info" @click="CheckManufacturerCode()"  :disabled="disabled" />
        </div>
    </div>
    <Dialog v-model:visible="showDialog" modal header="Manufacturer Code" :style="{ width: '60vw' }">
        <div>
            <template v-if="Category == 'A'">
                <DataTable 
                v-model:selection="selectedSapManufacturerCode"
                :value="ManufacturerCode_lst" dataKey="LIFNR" tableStyle="min-width: 40rem">
                    <Column selectionMode="single" headerStyle="width: 3rem"></Column>
                    <Column field="SORTL" header="Search Term"></Column>
                    <Column field="LIFNR" header="Manufacturer Code"></Column>
                    <Column field="NAME" header="Name"></Column>
                </DataTable>

            </template>
            <template v-else>
                <DataTable 
                v-model:selection="selectedSapManufacturerCode"
                :value="ManufacturerCode_lst" dataKey="LIFNR" tableStyle="min-width: 40rem">
                    <Column selectionMode="multiple" headerStyle="width: 3rem"></Column>
                    <Column field="SORTL" header="Search Term"></Column>
                    <Column field="LIFNR" header="Manufacturer Code"></Column>
                    <Column field="NAME" header="Name"></Column>
                </DataTable>
            </template>
            <br />
            <Button label="確定" @click="Confirm"></Button>
        </div>
    </Dialog>
    
       
        <DataTable
        :class="{'p-invalid': isError}"  
        :value="selectedManufacturerCode" 
        dataKey="ManufacturerCode" 
        paginator :rows="5"
        :rowsPerPageOptions="[5, 10, 20, 50]">
            <Column :exportable="false" bodyStyle="padding: 0rem 1rem;" header="Delete" headerStyle="padding: 0.5rem 1rem;">
                <template #body="slotProps">
                    <Button v-model="selectedManufacturerCode" :value="slotProps.data" icon="pi pi-trash" severity="danger"
                        text @click="DeleteManufacturerCode(slotProps.data.MFGCode)"
                        style="width: 50%;padding: 0.3rem;" />
                </template>
            </Column>
                <Column field="MFGSearchTerm" header="Search Term" bodyStyle="padding: 0rem 1rem;" headerStyle="padding: 0.5rem 1rem;"></Column>
                <Column field="MFGCode" header="Manufacturer Code" bodyStyle="padding: 0rem 1rem;"
                headerStyle="padding: 0.5rem 1rem;"></Column>
                <Column field="MFGName" header="Name" bodyStyle="padding: 0rem 1rem;" headerStyle="padding: 0.5rem 1rem;"></Column>
         </DataTable>
    </div>
</template>  
<script>
 


import Service from "../../service/service";
import SapService from "../../service/SapService";


export default {
    props: ["modelValue", "Category", 'disabled'],
    emits: ["update:modelValue"],
    data() {
        return {
            value:[],
            ManufacturerCode: "",
            displayTable: "none",
            ManufacturerCode_lst: [],
            selectedSapManufacturerCode: [],
            selectedManufacturerCode: [],
            selectedAll: "",
            placeholder: "請先選擇Supplier type",
            v_data: [],
            showDialog: false,
            USERBG: this.$store.state.user?.bg,
            USERRoles: this.$store.state.user?.roles,
            UserID: this.$store.state.user?.id,
        }
    },
    Service: null,
    SapService: null,
    
    created() {
        this.Service = new Service();
        this.SapService = new SapService();
        /* [JavaScript] JSON.stringify() and JSON.parse() */
         if(this.modelValue){
            this.selectedManufacturerCode=this.modelValue;
        } 
            
       if(!this.selectedManufacturerCode){
        this.selectedManufacturerCode=[];
       }
       if(!Array.isArray(this.selectedManufacturerCode)){
        this.selectedManufacturerCode=[];
       } 

        if (this.Category && this.Category != undefined && this.Category != "D") {
            this.IsDisabled = false;
            this.placeholder = "Manufacturer Code"
        }

       
    },
    /* watch: {
        'Category': function () {
            console.log('Category change')
            console.log(this.Category);
              // watch it
             // console.log("Prop changed: ", newVal, " | was: ", oldVal);
              this.selectedManufacturerCode = [];
            },
    }, */
    methods: {
       /*  PassManufacturerCode() {
            if (this.selectedManufacturerCode.length > 1 && this.Category == "A") {
                this.selectedManufacturerCode.splice(0, 1)
            }
            this.$emit('update:ManufacturerCode_outside', this.selectedManufacturerCode);
        }, */
        async CheckManufacturerCode() {
            let self=this;

        if(!this.Category || this.Category==''){
            alert('Supplier Type not selected!');
            return;
        }
        if(!this.ManufacturerCode || this.ManufacturerCode==''){
            alert('ManufacturerCode not keyin!');
            return;
        }

            this.ManufacturerCode_lst = []
            const ManufacturerCode_ = this.ManufacturerCode == undefined ? "" : this.ManufacturerCode.toUpperCase().split(';')

            if (this.Category == "A" && ManufacturerCode_.length > 1) {
                this.$toast.add({
                    severity: 'warn', summary: 'Warn Message', detail: '當Supplier Type = A, Manufacturer 只能key in 一筆', life: 3000
                });
                return
            }


            this.ManufacturerCode_lst = [];
            this.v_data = []

           // let lstVendor = []

            if (this.ManufacturerCode.length > 0 && ManufacturerCode_.length>0) {
               /*  for (let i = 0; i < ManufacturerCode_.length; i++) {
                    const x = ManufacturerCode_[i];
                    if (i != ManufacturerCode_.length - 1)
                    lstVendor.push() += 'lstVendor=' + x + '&'
                    else
                        lstVendor += 'lstVendor=' + x
                } */
                await this.SapService.GetSAPMFG(ManufacturerCode_).then((data) => {
                    self.ManufacturerCode_lst = data;
                })
        
            }


            if (this.Category == 'A') {

                let MFGSearchTerm1='';
                if(self.selectedManufacturerCode.length>0){
                    MFGSearchTerm1 = self.selectedManufacturerCode[0].MFGSearchTerm
                 }
                 let MFGSearchTerm2='';
                 if(this.ManufacturerCode_lst.length>0){
                    MFGSearchTerm2 = this.ManufacturerCode_lst[0].SORTL
                           
                 }
                 if(self.selectedManufacturerCode.length>0 && MFGSearchTerm1!=MFGSearchTerm2){
                    alert('Type A has already One Search Term !');
                    return;
                 }


                this.ManufacturerCode_lst.forEach(x=>{
                let find= self.selectedManufacturerCode.find(y=>y.MFGCode==x.LIFNR);
                if(find==undefined){
                    let o={
                        MFGCode:x.LIFNR,
                        MFGName:x.NAME,
                        MFGSearchTerm:x.SORTL,
                        BG:x.BG,
                    } 
                    self.selectedManufacturerCode.push(o);
                }
            })
        }
        else {

            if (this.ManufacturerCode_lst.length == 0) {
                this.$toast.add({
                    severity: 'warn', summary: 'Warn Message', detail: '查無資料', life: 3000
                });
                this.showDialog = false
            }
            else {
                this.showDialog = true
            }

        }



           
        },
        AllManufacturerCode() {
            if (this.selectedAll.length > 0) {
                this.selectedManufacturerCode = []
                this.ManufacturerCode_lst.forEach(x => {
                    if (!x.disable)
                        this.selectedManufacturerCode.push(x)
                })
            } else {
                this.selectedManufacturerCode = []
            }
            this.PassManufacturerCode()
        },
        DeleteManufacturerCode(ManufacturerCode) {

            const index = this.selectedManufacturerCode.findIndex((element) => {
            return element.MFGCode == ManufacturerCode
            });
            if(index!=-1){
                this.selectedManufacturerCode.splice(index, 1);
            }
    
            
            if (this.selectedManufacturerCode.length > 0)
                this.displayTable = ''
            else
                this.displayTable = "none"
        },
        Confirm() {

            let self=this;
            if (this.Category == 'A') {
                if (this.selectedManufacturerCode.length ==1 ) {
                    this.$toast.add({
                        severity: 'warn', summary: 'Warn Message', detail: 'A: Manufacturer 只能選擇一個Manufacturer Code', life: 3000
                    })
                    return
                }
            }
            this.showDialog = false;

            if (this.Category == 'A') {
                if(this.selectedSapManufacturerCode){

                       



                    let o={
                        MFGCode:this.selectedSapManufacturerCode.LIFNR,
                        MFGName:this.selectedSapManufacturerCode.NAME,
                        MFGSearchTerm:this.selectedSapManufacturerCode.SORTL,
                        BG:this.selectedSapManufacturerCode.BG,
                    } 
                   self.selectedManufacturerCode.push(o);
                }
            }
            else {
                this.selectedSapManufacturerCode.forEach(x=>{
                let find= self.selectedManufacturerCode.find(y=>y.MFGCode==x.LIFNR);
                if(find==undefined){
                    let o={
                        MFGCode:x.LIFNR,
                        MFGName:x.NAME,
                        MFGSearchTerm:x.SORTL,
                        BG:x.BG,
                    } 
                    self.selectedManufacturerCode.push(o);
                }
            })
            }

           
            this.$emit("update:modelValue", self.selectedManufacturerCode );
           
            if (this.selectedManufacturerCode.length > 0)
                this.displayTable = ''
            else
                this.displayTable = "none"
        }
    },
    watch: {
        Category: function() {
            if (this.Category && this.Category != undefined && this.Category != "D") {
                this.IsDisabled = false;
                this.placeholder = "Manufacturer Code"
            }
            else if (this.Category == "D") {
                this.IsDisabled = true;
                this.placeholder = "XX Material supplier 不需要 key in Manufacturer Code"
            }
            else {
                this.IsDisabled = true;
            }
            this.selectedManufacturerCode = [];
        },
        selectedManufacturerCode: function () {
              // watch it
             // console.log("Prop changed: ", newVal, " | was: ", oldVal);
              this.$emit("update:modelValue", this.selectedManufacturerCode );
            },
    },
    computed: {
     isError() {
            return    !this.disabled && this.selectedManufacturerCode.length==0    ;
    },
    isLoading() {
      return this.$store.state.isLoading;
      //return false;
    },
    user() {
     return this.$store.state.user;
    },
    user_userName() {
     return this.$store.state.user?.userName;
    },
    user_buyerMapping() {
     return this.$store.state.user?.buyerMapping;
    },
    user_sourcerMapping() {
     return this.$store.state.user?.sourcerMapping;
    },
    user_vendorMapping() {
     return this.$store.state.user?.vendorMapping;
    },
    user_mfgcode() {
     return this.$store.state.user?.mfgcode;
    },
    user_mfgsearchterm() {
     return this.$store.state.user?.mfgsearchterm;
    },
    user_roles() {
     return this.$store.state.user?.Roles;
    },
    clientId() {
     return this.$store.state.user?.clientId;
    },


    is_VIPAdmin(){
       return this.user_roles && this.user_roles.includes('VIPAdmin');
    },
    is_SCSI(){
       return this.user_roles && this.user_roles.includes('SCSI');
    },
    is_Sourcer(){
       return this.user_roles && this.user_roles.includes('Sourcer');
    },
    is_Buyer(){
       return this.user_roles && this.user_roles.includes('Buyer');
    },
    is_CompalUser(){
       return this.user_roles && this.user_roles.includes('CompalUser');
    },
    is_VendorUser(){
       return this.user_roles && this.user_roles.includes('VendorUser');
    },
    is_Supervisor(){
       return this.user_roles && this.user_roles.includes('Supervisor');
    },
    token() {
     return this.$store.state.token;
    },
    refreshToken() {
     return this.$store.state.refreshToken;
    },
    sessionCode() {
     return this.$store.state.sessionCode;
    },


     

  },
}
</script>
  
<style scoped>
.hasError label {
  color:red;
  border-color: red;
  border-width: thin;
}
.hasError  {
  color:red;
  border-color: red;
  border-width: thin;
  border: 1px solid;
  border-radius: 5px;
}
</style>